import React, {useState} from "react";
import ReactDOM from "react-dom/client";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { getLibrary } from "./utils/web3React";
import { Web3ReactProvider } from "@web3-react/core";
import "./index.css";
import App from "./App";
import { WagmiConfig } from "wagmi";
import reportWebVitals from "./reportWebVitals";
import { render } from "react-dom"; // add this
import { chains, config } from "./wagmi.ts";
import "@rainbow-me/rainbowkit/styles.css";
//const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <WagmiConfig config={config}>
      <RainbowKitProvider chains={chains}>
        <Web3ReactProvider getLibrary={getLibrary}>
          <App />
        </Web3ReactProvider>
      </RainbowKitProvider>
    </WagmiConfig>
  </React.StrictMode>
);
